import React, { useState } from "react";
import "./manager.css";

function ManagerUser() {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <div className="manager-user-page">

      {/* HEADER */}
      <div className="manager-top-header">
        <div>
          <h2>Quản lý người dùng</h2>

          <div className="manager-breadcrumb">
            Trang chủ / Quản trị hệ thống / Quản lý người dùng
          </div>
        </div>

        <button className="manager-add-btn" onClick={handleOpenModal}>
          <i className="fa-solid fa-plus"></i>
          Thêm người dùng
        </button>
      </div>

      {/* FILTER */}
<div className="filter-wrapper-user">

  <div className="filter-box-user">

    <div className="filter-item-user search-item">
      <label>Tìm kiếm</label>

      <div className="search-input-fil">
        <input
          type="text"
          placeholder="Nhập tên người dùng, họ tên, email, số điện thoại..."
        />

        <i className="fa-solid fa-magnifying-glass"></i>
      </div>
    </div>

    <div className="filter-item-user">
      <label>Vai trò</label>

      <select>
        <option>-- Tất cả vai trò --</option>
      </select>
    </div>

    <div className="filter-item-user">
      <label>Trạng thái</label>

      <select>
        <option>-- Tất cả trạng thái --</option>
      </select>
    </div>

    <div className="filter-item-user">
      <label>Đơn vị</label>

      <select>
        <option>-- Tất cả đơn vị --</option>
      </select>
    </div>

  </div>

  {/* BUTTON */}
  <div className="button-group-user">

    <button className="reset-btn">
      <i className="fa-solid fa-rotate-right"></i>
      Đặt lại
    </button>

    <button className="search-btn">
      <i className="fa-solid fa-magnifying-glass"></i>
      Tìm kiếm
    </button>

  </div>

</div>


      {/* TABLE CARD */}
      <div className="manager-table-card">

        <div className="manager-table-header">
          <h3>Danh sách người dùng</h3>

          <div className="manager-table-actions">
            <button>
              <i className="fa-solid fa-file-excel"></i>
              Xuất Excel
            </button>

            <button>
              <i className="fa-solid fa-upload"></i>
              Nhập dữ liệu
            </button>

            <button className="manager-setting-btn">
              <i className="fa-solid fa-gear"></i>
            </button>
          </div>
        </div>

        {/* TABLE */}
        <div className="manager-table-wrapper">

          <table className="manager-table">

            <thead>
              <tr>
                <th>
                  <input type="checkbox" />
                </th>

                <th>STT</th>
                <th>Họ và tên</th>
                <th>Tên đăng nhập</th>
                <th>Email</th>
                <th>Số điện thoại</th>
                <th>Vai trò</th>
                <th>Đơn vị</th>
                <th>Trạng thái</th>
                <th>Thao tác</th>
              </tr>
            </thead>

            <tbody>

              <tr>
                <td><input type="checkbox" /></td>
                <td>1</td>
                <td>Nguyễn Văn An</td>
                <td>nguyenvanan</td>
                <td>nguyenvanan@angiang.gov.vn</td>
                <td>0912345678</td>

                <td>
                  <span className="role role-red">
                    Quản trị hệ thống
                  </span>
                </td>

                <td>Sở Công Thương</td>

                <td>
                  <span className="status status-green">
                    Hoạt động
                  </span>
                </td>

                <td>
                  <div className="manager-action-icons">
                    <i className="fa-regular fa-eye"></i>
                    <i className="fa-regular fa-pen-to-square"></i>
                    <i className="fa-regular fa-trash-can"></i>
                  </div>
                </td>
              </tr>

              <tr>
                <td><input type="checkbox" /></td>
                <td>2</td>
                <td>Trần Thị Bình</td>
                <td>tranthibinh</td>
                <td>tranthibinh@angiang.gov.vn</td>
                <td>0909234567</td>

                <td>
                  <span className="role role-blue">
                    Lãnh đạo
                  </span>
                </td>

                <td>Sở Công Thương</td>

                <td>
                  <span className="status status-green">
                    Hoạt động
                  </span>
                </td>

                <td>
                  <div className="manager-action-icons">
                    <i className="fa-regular fa-eye"></i>
                    <i className="fa-regular fa-pen-to-square"></i>
                    <i className="fa-regular fa-trash-can"></i>
                  </div>
                </td>
              </tr>

              <tr>
                <td><input type="checkbox" /></td>
                <td>3</td>
                <td>Lê Văn Cường</td>
                <td>levancuong</td>
                <td>levancuong@angiang.gov.vn</td>
                <td>0911222333</td>

                <td>
                  <span className="role role-green">
                    Cán bộ nghiệp vụ
                  </span>
                </td>

                <td>Phòng QL Công nghiệp</td>

                <td>
                  <span className="status status-green">
                    Hoạt động
                  </span>
                </td>

                <td>
                  <div className="manager-action-icons">
                    <i className="fa-regular fa-eye"></i>
                    <i className="fa-regular fa-pen-to-square"></i>
                    <i className="fa-regular fa-trash-can"></i>
                  </div>
                </td>
              </tr>

            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <div className="manager-pagination">

          <div className="manager-page-left">
            Hiển thị

            <select>
              <option>10</option>
            </select>

            dòng trên mỗi trang
          </div>

          <div className="manager-page-number">
            <button className="active">1</button>
            <button>2</button>
            <button>3</button>
            <button>4</button>
          </div>

        </div>

      </div>

{/* MODAL */}
{isOpen && (
  <div className="userManagementOverlay">

    <div className="userManagementModal">

      {/* HEADER */}
      <div className="userManagementModalHeader">

        <h2 className="userManagementModalTitle">
          Thêm người dùng
        </h2>

        <button
          className="userManagementCloseButton"
          onClick={handleCloseModal}
        >
          <i className="fa-solid fa-xmark"></i>
        </button>

      </div>

      {/* BODY */}
      <div className="userManagementModalBody">

        <h3 className="userManagementSectionTitleModal">
          Thông tin người dùng
        </h3>

        <div className="userManagementFormGrid">

          {/* USERNAME */}
          <div className="userManagementFormGroup">
            <label className="userManagementLabelModal">
              Tên đăng nhập <span>*</span>
            </label>

            <input
              type="text"
              className="userManagementInput"
              placeholder="Nhập tên đăng nhập"
            />
          </div>

          {/* FULLNAME */}
          <div className="userManagementFormGroup">
            <label className="userManagementLabelModal">
              Họ và tên <span>*</span>
            </label>

            <input
              type="text"
              className="userManagementInput"
              placeholder="Nhập họ và tên"
            />
          </div>

          {/* EMAIL */}
          <div className="userManagementFormGroup">
            <label className="userManagementLabelModal">
              Email <span>*</span>
            </label>

            <input
              type="email"
              className="userManagementInput"
              placeholder="Nhập email"
            />
          </div>

          {/* PHONE */}
          <div className="userManagementFormGroup">
            <label className="userManagementLabelModal">
              Số điện thoại
            </label>

            <input
              type="text"
              className="userManagementInput"
              placeholder="Nhập số điện thoại"
            />
          </div>

          {/* ROLE */}
          <div className="userManagementFormGroup">
            <label className="userManagementLabelModal">
              Vai trò <span>*</span>
            </label>

            <select className="userManagementSelect">
              <option>-- Chọn vai trò --</option>
            </select>
          </div>

          {/* UNIT */}
          <div className="userManagementFormGroup">
            <label className="userManagementLabelModal">
              Đơn vị <span>*</span>
            </label>

            <select className="userManagementSelect">
              <option>-- Chọn đơn vị --</option>
            </select>
          </div>

          {/* PASSWORD */}
          <div className="userManagementFormGroup">
            <label className="userManagementLabelModal">
              Mật khẩu <span>*</span>
            </label>

            <div className="userManagementPasswordWrap">
              <input
                type="password"
                className="userManagementInput"
                placeholder="Nhập mật khẩu"
              />

              <i className="fa-regular fa-eye userManagementEye"></i>
            </div>
          </div>

          {/* CONFIRM PASSWORD */}
          <div className="userManagementFormGroup">
            <label className="userManagementLabelModal">
              Xác nhận mật khẩu <span>*</span>
            </label>

            <div className="userManagementPasswordWrap">
              <input
                type="password"
                className="userManagementInput"
                placeholder="Nhập lại mật khẩu"
              />

              <i className="fa-regular fa-eye userManagementEye"></i>
            </div>
          </div>

        </div>

        {/* STATUS */}
        <div className="userManagementStatusWrap">

          <label className="userManagementLabelModal">
            Trạng thái
          </label>

          <div className="userManagementRadioGroup">

            <label className="userManagementRadioLabel">
              <input
                type="radio"
                name="status"
                defaultChecked
              />

              Hoạt động
            </label>

            <label className="userManagementRadioLabel">
              <input
                type="radio"
                name="status"
              />

              Tạm khóa
            </label>

          </div>

        </div>

        {/* NOTE */}
        <div className="userManagementFormGroupFull">

          <label className="userManagementLabelModal">
            Ghi chú
          </label>

          <textarea
            className="userManagementTextarea"
            placeholder="Nhập ghi chú (nếu có)"
            maxLength={255}
          ></textarea>

          <div className="userManagementCountText">
            0/255
          </div>

        </div>

      </div>

      {/* FOOTER */}
      <div className="userManagementModalFooter">

        <button
          className="userManagementCancelButtonModal"
          onClick={handleCloseModal}
        >
          Hủy bỏ
        </button>

        <button className="userManagementSaveButton">
          <i className="fa-regular fa-floppy-disk"></i>
          Lưu người dùng
        </button>

      </div>

    </div>

  </div>
)}
    </div>
  );
}

export default ManagerUser;